import * as React from "react";
import { List } from "react-virtualized";
import { LegendRow } from "./LegendRow";
export const MINIMAL_LEGEND_ROW_HEIGHT = 18;
export const DEFAULT_LEGEND_ROW_HEIGHT = 43;
function buildLegendRowCreators(legendValues, legendProperties, minimal, toggleVariable, showLabel) {
    const legendKeys = Object.keys(legendValues);
    return legendKeys
        .filter((legendKeys) => legendProperties[legendKeys])
        .map((legendKey) => (key, style) => (React.createElement(LegendRow, { key: key, style: style, minimal: minimal, legendValue: legendValues[legendKey], legendDescription: legendProperties[legendKey].title, legendLineStyle: legendProperties[legendKey].style.lineStyle, legendSymbol: legendProperties[legendKey].style.symbol, color: legendProperties[legendKey].color, toggleVariable: () => toggleVariable(legendKey), yId: legendProperties[legendKey].yId, showLabel: showLabel })));
}
function buildObjectRowCreators(objectProperties, minimal) {
    const objectKeys = Object.keys(objectProperties);
    return objectKeys.map((objectKey) => (key, style) => (React.createElement(LegendRow, { key: key, style: style, minimal: minimal, legendValue: true, legendDescription: objectProperties[objectKey].title, legendLineStyle: objectProperties[objectKey].lineStyle, color: objectProperties[objectKey].color })));
}
export default function LegendList({ minimal, legendValues, legendProperties, height, objectProperties, showLabel, toggleVariable, }) {
    const rowHeight = minimal
        ? MINIMAL_LEGEND_ROW_HEIGHT
        : DEFAULT_LEGEND_ROW_HEIGHT;
    const legendRowCount = Object.keys(legendProperties).length;
    const objectRowCount = Object.keys(objectProperties).length;
    const legendRowCreators = buildLegendRowCreators(legendValues, legendProperties, minimal, toggleVariable, showLabel);
    const objectRowsCreators = buildObjectRowCreators(objectProperties, minimal);
    const separator = (key, style) => (React.createElement("div", { key: key, style: style },
        React.createElement("hr", { style: { marginTop: 10, marginBottom: 10 } })));
    const fullRowCreators = legendRowCount > 0 && objectRowCount > 0
        ? [...legendRowCreators, separator, ...objectRowsCreators]
        : [...legendRowCreators, ...objectRowsCreators];
    const rowCount = fullRowCreators.length;
    const computedHeight = height !== null
        ? Math.min(height, rowCount * rowHeight)
        : rowCount * rowHeight;
    return (React.createElement("div", null,
        React.createElement("div", { className: "legend", style: { height: computedHeight } },
            React.createElement(List, { width: 180, height: computedHeight, rowCount: rowCount, rowHeight: rowHeight, rowRenderer: ({ key, index, style }) => {
                    return fullRowCreators[index](key, style);
                }, overscanRowCount: 5 }))));
}
//# sourceMappingURL=LegendList.js.map